export const SIDE_NAV_STORAGE_KEY = 'theme.sideNavCollapse';

export const readSideNavPreference = () => {
	try {
		const stored = localStorage.getItem(SIDE_NAV_STORAGE_KEY);

		return stored === 'true' ? true : stored === 'false' ? false : null;
	} catch {
		return null;
	}
};

export const writeSideNavPreference = collapsed => {
	try {
		localStorage.setItem(SIDE_NAV_STORAGE_KEY, String(collapsed));
	} catch {
		return;
	}
};
